import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/timeline/index.js
// module id = 908
// module chunks = 14